<ng-template #exlargeModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">Documentos pertencentes ao projeto</h5>

        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Close click')"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between">
                        <div class=" align-self-end ">
                            <!-- @if(!podeEditarEmail){
                            <button title="Sem permissão" disabled type="button"
                                class="btn btn-light waves-effect btn-label waves-light">
                                <i class="bx bx-block label-icon"></i>Selecionar e enviar
                            </button>
                            }@else {
                            <button type="button" class="btn btn-light waves-effect btn-label waves-light">
                                <i class="bx bx-mail-send label-icon"></i>Selecionar e enviar
                            </button>
                            } -->
                        </div>
                        <div class=" align-self-end ">
                            @if(!podeEditarAdicionarDoc){
                            <button disabled type="text" title="Sem permissão" class="btn btn-light waves-effect">
                                <i class="bx bx-block btn-sm font-size-16 align-middle me-2"></i>Adicionar Documento
                            </button>
                            }@else {
                            <button (click)="abrirModalDocumento()" class="btn btn-sm btn-primary">Adicionar
                                Documento</button>
                            }
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-striped mb-0">

                                <thead>
                                    <tr>
                                        <th>Documento</th>
                                        <th>Descrição</th>
                                        <th>Status</th>
                                        <th>Atualizado Em</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @if (documentoService.loading) {
                                    <tr>
                                        <td colspan="7" class="text-center position-relative">
                                            <div class="d-flex justify-content-center align-items-center"
                                                style="height: 150px">
                                                <span class="spinner-border" style="width: 3rem; height: 3rem"
                                                    role="status" aria-hidden="true"></span>
                                            </div>
                                        </td>
                                    </tr>
                                    } @else {
                                    @for (row of listaDocumentos; track $index)
                                    {

                                    <tr>
                                        <td [ngSwitch]="row.tipoDocumento">
                                            <span *ngSwitchCase="0">Briefing</span>
                                            <span *ngSwitchCase="1">Projeto Arquiteto</span>
                                            <span *ngSwitchCase="2">Orçamento</span>
                                            <span *ngSwitchCase="3">Proposta Comercial</span>
                                            <span *ngSwitchCase="4">Contrato</span>
                                            <span *ngSwitchDefault>Desconhecido</span>
                                        </td>
                                        <td>{{ row.descricao }}</td>
                                        <td>{{ row.statusDocumento }}</td>
                                        <td>{{ row?.dataAtualizacao | date: 'dd/MM/yyyy HH:mm'}}</td>
                                        <td class="text-center actions-column">
                                            <div class="dropdown" ngbDropdown>


                                                @if(row.tipoDocumento == 1){
                                                @if(!podeEditarProjetoArquiteto){
                                                <i title="Sem permissão"
                                                    class="bx bx-block font-size-16 align-middle"></i>
                                                }@else {

                                                <button
                                                    class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                                    type="button" ngbDropdownToggle aria-expanded="false">
                                                    <i class="bx bx-dots-horizontal-rounded"></i>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                                    <li>
                                                        <button (click)="redirecionarParaDocumento(row)"
                                                            class="dropdown-item" data-bs-target="#staticBackdrop"
                                                            data-bs-toggle="modal">
                                                            Editar Documento
                                                        </button>

                                                    </li>
                                                </ul>
                                                }
                                                }@else if (row.tipoDocumento == 2) {
                                                @if(!podeEditarOrcamento){
                                                <i title="Sem permissão"
                                                    class="bx bx-block font-size-16 align-middle"></i>
                                                }@else {
                                                <button
                                                    class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                                    type="button" ngbDropdownToggle aria-expanded="false">
                                                    <i class="bx bx-dots-horizontal-rounded"></i>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                                    <li>
                                                        <button (click)="redirecionarParaDocumento(row)"
                                                            class="dropdown-item" data-bs-target="#staticBackdrop"
                                                            data-bs-toggle="modal">
                                                            Editar Documento
                                                        </button>

                                                        <button (click)="atualizarStatusDocumento(row)"
                                                            class="dropdown-item" data-bs-target="#staticBackdrop"
                                                            data-bs-toggle="modal">
                                                            Atualizar Status
                                                        </button>

                                                    </li>
                                                </ul>
                                                }
                                                }@else if (row.tipoDocumento == 3) {
                                                @if(!podeEditarProposta){
                                                <i title="Sem permissão"
                                                    class="bx bx-block font-size-16 align-middle"></i>
                                                }@else {
                                                <button
                                                    class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                                    type="button" ngbDropdownToggle aria-expanded="false">
                                                    <i class="bx bx-dots-horizontal-rounded"></i>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                                    <li>
                                                        <button (click)="redirecionarParaDocumento(row)"
                                                            class="dropdown-item" data-bs-target="#staticBackdrop"
                                                            data-bs-toggle="modal">
                                                            Editar Documento
                                                        </button>

                                                    </li>
                                                </ul>
                                                }
                                                }@else if (row.tipoDocumento == 4) {
                                                @if(!podeEditarContrato){
                                                <i title="Sem permissão"
                                                    class="bx bx-block font-size-16 align-middle"></i>
                                                }@else {
                                                <button
                                                    class="btn btn-link font-size-16 shadow-none py-0 text-muted dropdown-toggle"
                                                    type="button" ngbDropdownToggle aria-expanded="false">
                                                    <i class="bx bx-dots-horizontal-rounded"></i>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                                                    <li>
                                                        <button (click)="redirecionarParaDocumento(row)"
                                                            class="dropdown-item" data-bs-target="#staticBackdrop"
                                                            data-bs-toggle="modal">
                                                            Editar Documento
                                                        </button>

                                                        <button (click)="atualizarStatusDocumento(row)"
                                                            class="dropdown-item" data-bs-target="#staticBackdrop"
                                                            data-bs-toggle="modal">
                                                            Atualizar Status
                                                        </button>

                                                    </li>
                                                </ul>
                                                }
                                                }


                                            </div>
                                        </td>
                                    </tr>
                                    }
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!-- end card body -->
                </div>
                <!-- end card -->
            </div>
        </div>
    </div>
</ng-template>